import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Apply the headers

    if (req.url.indexOf("paypal") != null) {
      var authToken = localStorage.getItem("currentAuthToken");
      if (authToken != undefined && authToken != null && authToken != "") {
        req = req.clone({
          setHeaders: {
            Authorization: "Bearer " + authToken,
          },
        });
      }
    }

    // Also handle errors globally
    return next.handle(req).pipe(
      tap(
        (x) => x,
        (err) => {
          // Handle this err
          console.error(
            `Error performing request, status code = ${err.status}`
          );
        }
      )
    );
  }
}
